module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row hidden-xs-down"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo_luna.png"),
      "alt": "Laboratório da Luna"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "download hidden-md-down"
  }, [_c('strong', {
    staticClass: "call-soon"
  }, [_vm._v("A melhor experiência de todas já está nas lojas")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apple.co/2HiipHl",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-button",
    attrs: {
      "src": require("../assets/btn-appStore.svg")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://bit.ly/2HiGtcZ",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-button",
    attrs: {
      "src": require("../assets/btn-googleplay.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper"
  }, [_c('iframe', {
    staticClass: "video",
    attrs: {
      "src": "https://player.vimeo.com/video/254011750?autoplay=0&color=F26722&title=0&byline=0&portrait=0",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "character character-luna"
  }), _vm._v(" "), _c('div', {
    staticClass: "character character-claudio"
  }), _vm._v(" "), _c('div', {
    staticClass: "character character-jupiter"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4640608","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 63
// module chunks = 0